'use client';
import DropBoxSearch from '@/app/eflayout/Header/DropBox/DropBoxSearch';

export default function SearchV1List({ prefixCls }: { prefixCls: string }) {
    return (
        <>
            <div className={`${prefixCls}-search`}>
                <DropBoxSearch />
            </div>
        </>
    );
}
